import { CircuitLabelsSchema } from '@/models/CircuitLabelsModel';
import { z } from 'zod';
import { TileInstanceDtoSchema } from '@/schemas/tiles';
import { CircuitTypeSchema, SideSchema } from '@/schemas/common';

const ConnectionPointDtoSchema = z.object({
  tileId: z.string(),
  side: SideSchema,
});

const ConnectionDtoSchema = z.object({
  a: ConnectionPointDtoSchema,
  b: ConnectionPointDtoSchema,
});

export const ConnectionGraphDtoSchema = z.object({
  connections: z.array(ConnectionDtoSchema),
  disconnected: z.array(ConnectionDtoSchema).optional(),
});

export const TileManagerDtoSchema = z.object({
  tiles: z.array(TileInstanceDtoSchema),
});

export const CircuitDtoSchema = z.object({
  labels: CircuitLabelsSchema.optional(),
  id: z.string().startsWith('circuit-'),
  circuitType: CircuitTypeSchema,
  tileManagerDto: TileManagerDtoSchema,
  connectionGraphDto: ConnectionGraphDtoSchema.optional(),
});
